import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

interface CoverProps {
  children: ReactNode;
  imageUrl?: string;
  tall?: boolean;
}

interface CoverImageProps {
  $tall?: boolean;
}

const Cover = ({ children, imageUrl, tall = false }: CoverProps) => (
  <>
    <Wrapper>
      <CoverImage
        className="bg-center"
        $tall={tall}
        style={{
          backgroundImage: `url(${imageUrl})`,
          aspectRatio: 1600 / 600,
          maxWidth: '100%',
          width: '100%',
          height: 'auto',
          backgroundSize: 'contain',
          margin: 'auto',
        }}
      />
    </Wrapper>
    <Box mt={{ _: 10, m: '60px' }}>{children}</Box>
  </>
);

export default Cover;

const Wrapper = styled(Box)`
  height: 0;
  overflow: visible;
`;

const CoverImage = styled(Box)<CoverImageProps>`
  height: 300px;
  @media (min-width: ${({ theme }) => theme.breakpoints.m}) {
    height: ${({ $tall }) => ($tall ? '600px' : '500px')};
  }
`;
